import React from 'react';
import { animated, useTransition } from '@react-spring/web';
import { Flex } from '~/ui/flex/Flex';
import { useOnboardingStore } from '../Store';
import { Autosaving } from './Autosaving';
import { Disclaimer } from './Disclaimer';
import { OnboardingCard } from './OnboardingCard';
import { Ready } from './Ready';
import { Volume } from './Volume';
import { PassFail } from './PassFail';
import { CourseDuration } from './CourseDuration';
import { TrainingState, useTrainingStore } from '~/training/state';
import { select } from '~/lib/select';

const cards = [
  { stage: 3, content: CourseDuration },
  { stage: 4, content: Disclaimer },
  { stage: 5, content: PassFail },
  { stage: 6, content: Autosaving },
  { stage: 7, content: Volume },
  { stage: 8, content: Ready }
];

const filterCards = (
  stage: number,
  {
    shouldDisplayCourseDurationCard
  }: {
    shouldDisplayCourseDurationCard: boolean | undefined;
  }
) => {
  if (stage === 3)
    return shouldDisplayCourseDurationCard ? cards : cards.slice(1);

  return stage < 4 || stage > 8 ? [] : cards.filter(c => c.stage >= stage);
};

const selector = (s: TrainingState) =>
  select(s, 'shouldDisplayCourseDurationCard');

export const Cards = () => {
  const stage = useOnboardingStore(s => s.stage);

  const { shouldDisplayCourseDurationCard } = useTrainingStore(selector);

  const filteredCards = filterCards(stage, { shouldDisplayCourseDurationCard });

  const transition = useTransition(filteredCards, {
    keys: item => item.stage,
    from: item => ({
      opacity: 0,
      transform: 'rotate(0deg) translateY(400px)',
      zIndex: 6 - item.stage,
      position: 'absolute'
    }),
    enter: item => ({
      opacity: 1,
      transform: `rotate(${(item.stage - stage) * 3}deg) translateY(0px)`
    }),
    update: item => ({
      opacity: 1,
      transform: `rotate(${(item.stage - stage) * 3}deg) translateY(0px)`
    }),
    leave: {
      opacity: 0,
      transform: 'rotate(0deg) translateY(-600px)'
    }
  });

  return (
    <Flex variant="center" position="fixed">
      {transition((style, item) => (
        <animated.div style={style}>
          <OnboardingCard>
            <item.content />
          </OnboardingCard>
        </animated.div>
      ))}
    </Flex>
  );
};
